module.exports = __webpack_public_path__ + "static/img/3.762e48f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/eng/3.png
// module id = DgpT
// module chunks = 0